export default {"src":"/_next/static/media/unit_left_arrow.fda42734.svg","height":47,"width":30,"blurWidth":0,"blurHeight":0};